import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../Auth/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import '../../css/header.css';
import MobileMenu from "./MenuMobile";
import MobileSearchOverlay from './MobileSearchOverlay';
import img from '../../assets/favicon4-4.png';
import { NavLink } from 'react-router-dom';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchOverlayOpen, setIsSearchOverlayOpen] = useState(false);
  const mobileMenuRef = useRef(null);
  const menuBtnRef = useRef(null);

  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleSearchOverlay = () => {
    setIsSearchOverlayOpen(!isSearchOverlayOpen);
  };

  const closeSearchOverlay = () => {
    setIsSearchOverlayOpen(false);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        menuBtnRef.current &&
        !menuBtnRef.current.contains(event.target)
      ) {
        closeMobileMenu();
      }
    };

    if (isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  return (
    <>
      {/* Header */}
      <header className="bg-white shadow-lg sticky top-0 z-50">
        <div className="container mx-auto px-4 py-3">
          <div className="header-layout">
            {/* Logo Section */}
            <div className="logo-section">
              <div className="flex items-center space-x-3 space-x-reverse">
                <div className="logo-container">
                  <img src={img} alt="لوگو هوش جدید" />
                </div>
                <div className="flex flex-col">
                  <span className="text-2xl font-bold text-dark">هوش جدید</span>
                  {/* <span className="text-sm text-primary font-medium">ترکیبی</span> */}
                </div>
              </div>
            </div>

            {/* Menu & Search Section */}
            <div className="menu-section">
              {/* Desktop Menu */}
              <nav className="nav-menu">
                <div className="flex space-x-1 space-x-reverse">
                  <NavLink to="/" exact activeClassName="active">خانه</NavLink>
                  <NavLink to="/courses" activeClassName="active">دوره‌ها</NavLink>
                  <NavLink to="/blog" activeClassName="active">مقالات</NavLink>
                  <NavLink to="/about" activeClassName="active">درباره ما</NavLink>
                  <NavLink to="/contact" activeClassName="active">تماس با ما</NavLink>
                  <NavLink to="/consultation" activeClassName="active">فرم مشاوره</NavLink>
                </div>
              </nav>

              {/* Desktop Search */}
              <div className="search-container">
                <input
                  type="text"
                  className="search-bar"
                  placeholder="جستجو..."
                  id="desktopSearch"
                />
                <svg
                  className="search-icon w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
            </div>

            {/* Action Section */}
            <div className="action-section">
              <div className="flex items-center gap-2">
                {/* Mobile Search Button */}
                <button
                  onClick={toggleSearchOverlay}
                  id="mobileSearchBtn"
                  className="search-button md:hidden"
                >
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </button>

                {/* Conditional Buttons: Profile & Logout (only for logged-in users) */}
                <div className="flex items-center gap-2">

                  {user ? (
                    <>
                      {/* Dashboard/Profile Button */}
                      <Link to="/dashboard" title="پروفایل کاربری">
                        <button className="flex btn-dash items-center justify-center gap-1 px-4 py-2 rounded-full bg-gray-100 hover:bg-gray-200 text-dark transition
                           sm:px-4 sm:py-2 sm:gap-1 sm:rounded-full
                           xs:px-3 xs:py-3 xs:gap-0 xs:rounded-full">
                          <i className="fa fa-user"></i>
                          <span className="hidden sm:inline">پروفایل</span> {/* متن فقط در sm و بالاتر */}
                        </button>
                      </Link>

                      {/* Logout Button (Only visible on lg and larger) */}
                      <button
                        onClick={handleLogout}
                        className="hidden lg:flex items-center gap-1 px-4 py-2 rounded-full bg-red-100 hover:bg-red-200 text-red-700 transition"
                        title="خروج از حساب کاربری"
                      >
                        <i className="fa fa-power-off"></i> خروج
                      </button>
                    </>
                  ) : (
                    // Login/Register Button for guests
                      <button className="cta-button btn-cta-header-desktop">
                    <Link to="/login">
                    🚀 ورود / ثبت نام
                    </Link>
                      </button>
                  )}
                </div>

                {/* Mobile Search Overlay */}
                <MobileSearchOverlay isOpen={isSearchOverlayOpen} onClose={closeSearchOverlay} />
                {/* Mobile Menu Button */}
                <button
                  id="menuBtn"
                  ref={menuBtnRef}
                  className="lg:hidden p-2 text-gray-700"
                  onClick={toggleMobileMenu}
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>



        {/* Mobile Menu */}
        <MobileMenu isOpen={isMobileMenuOpen} onClose={closeMobileMenu} ref={mobileMenuRef} />
      </header>
    </>
  );
};

export default Header;